<div class="container">
    <mat-grid-list [cols]="cols" rowHeight="40px">
        <mat-grid-tile class="cell-color"></mat-grid-tile>
        <div *ngFor="let cell of cells">
            <mat-grid-tile *ngIf="cell.inputType == 'labelText'; else elseBlock" class="cell-color" [colspan]="1"
                [rowspan]="1">
                <app-cell [cell]="cell" [isShortVersionNeeded]="isShortVersionNeeded"
                    (modelChanged)="updateMatrix($event)"></app-cell>
            </mat-grid-tile>
            <ng-template #elseBlock>
                <mat-grid-tile [colspan]="1" [rowspan]="1">
                    <app-cell [cell]="cell" (modelChanged)="updateMatrix($event)"></app-cell>
                </mat-grid-tile>
            </ng-template>
        </div>
    </mat-grid-list>
</div>